import { h, Component } from 'preact';
import dlv from 'dlv';
import pageStyles from '../../pages/pageStyles';
import { SadlibAd } from '../sadlib-ad';
import { TaboolaJs } from '../taboola-js';
import { ColumnSticky } from '@cube/layout';
import { RecentlyViewed,  StocksPanel } from '@cube/finance-components';
export class SideBar extends Component {

	defaultSideBar = (pageConfig, adPrefix) => (
		<ColumnSticky class={pageStyles.smallFixedRightColumn}>
			<SadlibAd id={`${adPrefix}_sidebar_top`} type="desktopRail" />
			<TaboolaJs {...dlv(pageConfig, 'taboola.rightRail')} qeId="sc-rightrail-taboola" />
			<SadlibAd id={`${adPrefix}_sidebar_bottom`} type="desktopRail" />
		</ColumnSticky>
	);

	financeSideBar = (adPrefix) => (
		<ColumnSticky class={pageStyles.smallFixedRightColumn}>
			<SadlibAd id={`${adPrefix}_sidebar_top`} type="desktopRail" />
			<RecentlyViewed />
			<StocksPanel />
			<SadlibAd id={`${adPrefix}_sidebar_bottom`} type="desktopRail" />
		</ColumnSticky>
	);

	render({ pageConfig, type, adPrefix, RecentlyViewed, StocksPanel }) {
		if (type && type === 'finance') return this.financeSideBar(adPrefix);

		return this.defaultSideBar(pageConfig, adPrefix);
	}
}
